import React, { Component } from 'react';
import "./events.css"
import EventCard from "../components/eventCard"
import bookSale1 from "../images/bookSale1.jpg";
const bookSaleInfo= "There's another Book Sale coming soon!  3,000+ books to peruse. Old and New!  Something for everyone, every age, action packed to cook book. Date and time yet to be announced.";

class eventsMobile2 extends Component {

    render() {
        const eventCard2Mobile = (
          <EventCard
          eventImage={bookSale1}
          title={"Book Sale"}
          information={
            <> 
            {bookSaleInfo}
            <br />
            <br />
                  <b>October 18, 2025</b> - 9:00am - 2:00pm Heritage Bank Parking Lot<br />
      <b>Febrauary 2025 </b>- LaSalle High School<br />
            </>
          }
          date={"October 2023"}
          width={"85%"}
          height={"auto"}
          startDate={"TBA"}
          endDate={"TBA"}
          startTime={"TBA"}
          endTime={"TBA"}
          location={"TBA"}
          
        ></EventCard>
          );
        return (
            <div>
                 <div className="eventsParent" >
        <div className="eventsContainer">
        <h1 className="eventsHeading">Events / Fundraisers</h1>
            <div className="eventCardContainerMobile">{eventCard2Mobile} </div>
        </div>
      </div>
            </div>
        );
    }
}

export default eventsMobile2;